// screen names are used in navigation, so they are unique
export const SCREENS = {
  // locale selector
  LocaleSelector: {
    name: "LocaleSelector" as const,
    path: ":locale?" as const,
    tracked: false,
  },

  // token resolver
  TokenResolver: {
    name: "TokenResolver" as const,
    path: "token" as const,
    tracked: true,
  },

  // shortener resolver
  ShortenerResolver: {
    name: "ShortenerResolver" as const,
    path: "s/:id" as const,
    tracked: true,
  },

  // root stack
  RootStack: {
    name: "RootStack" as const,
    path: "" as const,
    tracked: false,
  },

  // app stack
  AppStack: {
    name: "AppStack" as const,
    path: "" as const,
    tracked: false,
  },

  // bottom tab
  BottomTab: {
    name: "BottomTab" as const,
    path: "" as const,
    tracked: false,
  },

  // home stack
  HomeStack: {
    name: "HomeStack" as const,
    path: "" as const,
    tracked: false,
  },
  Home: {
    name: "HomeScreen" as const,
    path: "home" as const,
    tracked: true,
  },
  PostJob: {
    name: "PostJobScreen" as const,
    path: "home/post-job" as const,
    tracked: true,
  },
  Review: {
    name: "ReviewScreen" as const,
    path: "home/review/:id" as const,
    tracked: true,
  },
  HomeJobDetails: {
    name: "EditJobScreen" as const,
    path: "job/edit" as const,
    tracked: true,
  },
  ContractSignScreen: {
    name: "ContractSignScreen" as const,
    path: "contract-sign" as const,
    tracked: true,
  },
  Tandem: {
    name: "TandemScreen" as const,
    path: "home/tandem/:id" as const,
    tracked: true,
  },
  Notifications: {
    name: "NotificationScreen" as const,
    path: "home/notifications" as const,
    tracked: true,
  },

  // Job Details Stack
  JobDetailsStack: {
    name: "JobDetailsStack" as const,
    path: "" as const,
    tracked: false,
  },
  JobDetails: {
    name: "JobDetailsScreen" as const,
    path: "job-details" as const,
    tracked: true,
  },
  EditJobDetails: {
    name: "EditJobDetailsScreen" as const,
    path: "job-details/edit" as const,
    tracked: true,
  },

  // Invitations Stack
  InvitationsStack: {
    name: "InvitationsStack" as const,
    path: "invitations" as const,
    tracked: false,
  },
  InvitationsList: {
    name: "InvitationsScreen" as const,
    path: "" as const,
    tracked: true,
  },
  InvitationDetails: {
    name: "InvitationDetailsScreen" as const,
    path: ":id" as const,
    tracked: true,
  },

  // Applications Stack
  ApplicationsStack: {
    name: "ApplicationsStack" as const,
    path: "applications" as const,
    tracked: false,
  },
  ApplicationsList: {
    name: "ApplicationsScreen" as const,
    path: "" as const,
    tracked: true,
  },
  ApplicationDetails: {
    name: "ApplicationDetailsScreen" as const,
    path: ":id" as const,
    tracked: true,
  },

  // Dealroom Stack
  DealroomStack: {
    name: "DealroomStack" as const,
    path: "dealroom" as const,
    tracked: false,
  },
  DealroomList: {
    name: "DealroomScreen" as const,
    path: "" as const,
    tracked: true,
  },
  DealroomDetails: {
    name: "DealroomDetailsScreen" as const,
    path: ":id" as const,
    tracked: true,
  },

  // Offer Stack
  Offer: {
    name: "OfferScreen" as const,
    path: "offer/:id" as const,
    tracked: false,
  },
  OfferModal: {
    name: "UpsertOfferScreen" as const,
    path: "modify-offer" as const,
    tracked: true,
  },

  // offer top tab
  OfferDetailsTab: {
    name: "OfferDetailTab" as const,
    path: "" as const,
    tracked: true,
  },
  OfferDetails: {
    name: "OfferDetailsScreen" as const,
    path: "" as const,
    tracked: true,
  },
  OfferHistory: {
    name: "OfferHistoryScreen" as const,
    path: "history" as const,
    tracked: true,
  },

  // Home Job Tabs
  ActiveJob: {
    name: "ActiveJobScreen" as const,
    path: "active" as const,
    tracked: true,
  },
  LiveJob: {
    name: "LiveJobScreen" as const,
    path: "live" as const,
    tracked: true,
  },
  PastJobs: {
    name: "PastJobsScreen" as const,
    path: "jobs" as const,
    tracked: true,
  },
  CaregiverCaseDetail: {
    name: "CaregiverCaseDetailScreen" as const,
    path: ":id" as const,
    tracked: true,
  },

  // Caregiver PDF
  CaregiverPDF: {
    name: "CaregiverPDF" as const,
    path: "pdf/:id" as const,
    tracked: true,
  },

  // Caregiver stack
  CaregiverStack: {
    name: "CaregiverStack" as const,
    path: "caregivers" as const,
    tracked: false,
  },
  CaregiverList: {
    name: "CaregiverListScreen" as const,
    path: "" as const,
    tracked: true,
  },
  CaregiverDetail: {
    name: "CaregiverDetailScreen" as const,
    path: ":id" as const,
    tracked: true,
  },
  CaregiverDetailWithPrices: {
    name: "CaregiverDetailWithPrices" as const,
    path: "details/:id" as const,
    tracked: true,
  },
  CaregiverFilter: {
    name: "CaregiverFilterScreen" as const,
    path: "filter" as const,
    tracked: true,
  },
  CaregiverPDFDocument: {
    name: "CaregiverPDFDocumentScreen" as const,
    path: "pdf-document/:uri" as const,
    tracked: true,
  },

  // caregiver detail top tab
  CaregiverDetailTab: {
    name: "CaregiverDetailTab" as const,
    path: "" as const,
    tracked: false,
  },
  CaregiverAbout: {
    name: "CaregiverAboutScreen" as const,
    path: "" as const,
    tracked: true,
  },
  CaregiverMatching: {
    name: "CaregiverMatchingScreen" as const,
    path: "matching" as const,
    tracked: true,
  },
  CaregiverReviews: {
    name: "CaregiverReviewsScreen" as const,
    path: "reviews" as const,
    tracked: true,
  },

  // profile
  ProfileStack: {
    name: "ProfileStack" as const,
    path: "profile" as const,
    tracked: false,
  },
  Profile: {
    name: "ProfileScreen" as const,
    path: "" as const,
    tracked: true,
  },
  Settings: {
    name: "SettingsScreen" as const,
    path: "settings" as const,
    tracked: true,
  },
  NotificationSettings: {
    name: "NotificationSettingsScreen" as const,
    path: "settings/notifications" as const,
    tracked: true,
  },
  Help: {
    name: "HelpCenter" as const,
    path: "help" as const,
    tracked: true,
  },
  Feedback: {
    name: "FeedbackForm" as const,
    path: "feedback" as const,
    tracked: true,
  },
  PrivacyPolicy: {
    name: "PrivacyPolicy" as const,
    path: "settings/privacy-policy" as const,
    tracked: true,
  },

  // Invoice stack
  Invoices: {
    name: "Invoices" as const,
    path: "invoices" as const,
    tracked: false,
  },
  InvoiceList: {
    name: "InvoiceList" as const,
    path: "" as const,
    tracked: true,
  },
  InvoiceDetail: {
    name: "InvoiceDetail" as const,
    path: ":documentId" as const,
    tracked: true,
  },

  // Documents
  DocumentStack: {
    name: "DocumentStack" as const,
    path: "documents" as const,
    tracked: false,
  },
  DocumentList: {
    name: "DocumentList" as const,
    path: "" as const,
    tracked: true,
  },
  DocumentDetail: {
    name: "DocumentDetail" as const,
    path: ":id" as const,
    tracked: true,
  },

  // auth stack
  AuthStack: {
    name: "AuthStack" as const,
    path: "" as const,
    tracked: false,
  },
  // auth stack v2
  LoginCode: {
    name: "LoginCodeScreen" as const,
    path: "login" as const,
    tracked: true,
  },
  LoginVerify: {
    name: "LoginVerifyScreen" as const,
    path: "login/verify" as const,
    tracked: true,
  },
  LoginPassword: {
    name: "LoginPasswordScreen" as const,
    path: "login/password" as const,
    tracked: true,
  },
  ForgotPasswordV2: {
    name: "ForgotPasswordV2Screen" as const,
    path: "login/reset" as const,
    tracked: true,
  },
  AuthConflict: {
    name: "AuthConflictScreen" as const,
    path: "auth/conflict" as const,
    tracked: true,
  },
  RegisterV2: {
    name: "RegisterV2Screen" as const,
    path: "register" as const,
    tracked: true,
  },
  RegisterDetails: {
    name: "RegisterDetailsScreen" as const,
    path: "register/details" as const,
    tracked: true,
  },
  RegisterPassword: {
    name: "RegisterPasswordScreen" as const,
    path: "register/password" as const,
    tracked: true,
  },

  Welcome: {
    name: "WelcomeScreen" as const,
    path: "welcome" as const,
    tracked: true,
  },

  Unsubscribe: {
    name: "UnsubscribeScreen" as const,
    path: "unsubscribe" as const,
    tracked: true,
  },

  // Account delete stack
  AccountDeleteStack: {
    name: "AccountDeleteStack" as const,
    path: "account" as const,
    tracked: false,
  },
  AccountDelete: {
    name: "AccountDelete" as const,
    path: "delete" as const,
    tracked: true,
  },
  AccountDeleteConfirmation: {
    name: "AccountDeleteConfirmationScreen" as const,
    path: "confirm-delete" as const,
    tracked: true,
  },
  AccountDeleteError: {
    name: "AccountDeleteErrorScreen" as const,
    path: "delete-error" as const,
    tracked: true,
  },

  // Disclaimers stack
  Disclaimers: {
    name: "Disclaimers" as const,
    path: "disclaimers",
    tracked: false,
  },
  TermsOfUse: {
    name: "TermsOfUse" as const,
    path: "terms-of-use" as const,
    tracked: true,
  },
  SampleContract: {
    name: "SampleContract" as const,
    path: "sample-contract" as const,
    tracked: true,
  },

  // Inquiry stack
  InquiryStack: {
    name: "InquiryStack" as const,
    path: "inquiry" as const,
    tracked: false,
  },
  Inquiry: {
    name: "Inquiry" as const,
    path: "" as const,
    tracked: false,
  },
  InquiryOld: {
    name: "InquiryOld" as const,
    path: "o" as const,
    // we are tracking this screen inside the screen component itself
    tracked: false,
  },
  InquiryYankee: {
    name: "InquiryYankee" as const,
    path: "y" as const,
    // we are tracking this screen inside the screen component itself
    tracked: false,
  },
  InquiryZulu: {
    name: "InquiryZulu" as const,
    path: "z" as const,
    // we are tracking this screen inside the screen component itself
    tracked: false,
  },
  InquiryPartner: {
    name: "InquiryPartner" as const,
    path: "p" as const,
    // we are tracking this screen inside the screen component itself
    tracked: false,
  },

  // Wizard stack
  WizardStack: {
    name: "WizardStack" as const,
    path: "wizard/:formKey" as const,
    tracked: false,
  },
  WizardIntro: {
    name: "WizardIntro" as const,
    path: "" as const,
    tracked: true,
  },
  WizardSection: {
    name: "WizardSection" as const,
    path: "section" as const,
    tracked: true,
  },
  WizardCompleted: {
    name: "WizardCompleted" as const,
    path: "section/completed" as const,
    tracked: true,
  },
  WizardNotFound: {
    name: "WizardNotFound" as const,
    path: "not-found" as const,
    tracked: true,
  },

  // Session
  ConfirmEmail: {
    name: "ConfirmEmail" as const,
    path: "confirm-email" as const,
    tracked: true,
  },
  ResetPassword: {
    name: "ResetPassword" as const,
    path: "reset-password" as const,
    tracked: true,
  },
  SetPassword: {
    name: "SetPassword" as const,
    path: "set-password" as const,
    tracked: true,
  },

  // Messages
  Messages: {
    name: "Messages" as const,
    path: "messages" as const,
    tracked: true,
  },
  MessageList: {
    name: "Messages" as const,
    path: "" as const,
    tracked: true,
  },
  MessageDetails: {
    name: "MessageDetails" as const,
    path: "/details/:roomId" as const,
    tracked: false,
  },
  Message: {
    name: "Message" as const,
    path: ":roomId" as const,
    tracked: false,
  },
  MessageProfile: {
    name: "MessageProfile" as const,
    path: "profile/:id" as const,
    tracked: false,
  },
  // Devices
  Devices: {
    name: "Devices" as const,
    path: "devices" as const,
    tracked: false,
  },
  DeviceList: {
    name: "Devices" as const,
    path: "" as const,
    tracked: false,
  },
  DeviceDetail: {
    name: "DeviceDetail" as const,
    path: "/devices/:deviceId" as const,
    tracked: false,
  },
};

type ScreenKey = keyof typeof SCREENS;

export const nameMappedScreens = Object.keys(SCREENS).reduce(
  (acc, key) => ({
    ...acc,
    [SCREENS[key as ScreenKey].name]: SCREENS[key as ScreenKey],
  }),
  {} as { [key in keyof typeof SCREENS]: (typeof SCREENS)[key] },
);
